import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import { toast, DatePicker } from '@livable/saas-react-components';
import { Typography, TextField, Button, ToggleButtonGroup, ToggleButton, FormHelperText, FormControl, FormControlLabel, Checkbox } from '@mui/material';
import InformationBanner from 'src/components/shared/InformationBanner';
import RangeDatePicker from 'src/components/general/RangeDatePicker';
import useStyles from './styles';
import { useStore } from 'src/stores';
import { beforeSubmitDataValidation } from 'src/core/services/beforeSubmitDataValidation';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { formatISO } from 'date-fns';
import { BackdropLoader } from '@livable/saas-react-components';
import { NOTIFICATION_DEFAULT } from 'src/constants/notifications';
import ReactQuill, { Quill } from 'react-quill';
import quillEmoji from 'react-quill-emoji';
import 'react-quill/dist/quill.snow.css';
import 'react-quill-emoji/dist/quill-emoji.css';
import DOMPurify from 'dompurify';
const modules = {
  toolbar: {
    container: [['bold', 'italic', 'underline', 'strike'], [{
      list: 'ordered'
    }, {
      list: 'bullet'
    }], [{
      header: [1, 2, 3, 4, 5, 6, false]
    }], [{
      color: []
    }], ['emoji']]
  },
  'emoji-toolbar': true
};
export const InformationBannersAddForm = observer(_ref => {
  let handleModalClose = _ref.handleModalClose,
    currentId = _ref.currentId,
    isOpen = _ref.isOpen;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  Quill.register({
    'formats/emoji': quillEmoji.EmojiBlot
  }, true);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isTitleEdited = _useState2[0],
    setIsTitleEdited = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isBodyEdited = _useState4[0],
    setIsBodyEdited = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isButtonLinkEdited = _useState6[0],
    setIsButtonLinkEdited = _useState6[1];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isButtonTitleEdited = _useState8[0],
    setIsButtonTitleEdited = _useState8[1];
  const handleSubmit = async () => {
    const data = {
      title: store.notifications.newNotification.title,
      body: store.notifications.newNotification.body,
      startDateOnly: store.notifications.newNotification.startDateOnly,
      endDateOnly: store.notifications.newNotification.appearanceType !== 'banner' || store.notifications.newNotification.dates === 'start' ? null : store.notifications.newNotification.endDateOnly,
      showButton: store.notifications.newNotification.appearanceType !== 'banner' || store.notifications.newNotification.appearanceType !== 'banner' ? false : store.notifications.newNotification.button === 'visible',
      buttonTitle: store.notifications.newNotification.button !== 'visible' || store.notifications.newNotification.appearanceType !== 'banner' ? null : store.notifications.newNotification.buttonTitle,
      buttonUrl: store.notifications.newNotification.button !== 'visible' || store.notifications.newNotification.appearanceType !== 'banner' ? null : store.notifications.newNotification.buttonLink,
      notificationType: store.notifications.newNotification.type,
      appearanceType: store.notifications.newNotification.appearanceType,
      termsOfConditions: store.notifications.newNotification.appearanceType === 'banner' ? '' : !!store.notifications.newNotification.termsOfConditions ? 'true' : '',
      privacyPolicy: store.notifications.newNotification.appearanceType === 'banner' ? '' : !!store.notifications.newNotification.privacyPolicy ? 'true' : '',
      userAcknowledgement: store.notifications.newNotification.appearanceType === 'banner' ? '' : !!store.notifications.newNotification.userAcknowledgement ? 'true' : ''
    };
    let resp;
    if (currentId) {
      data.id = currentId;
      resp = await store.notifications.putSpecificNotificationsAsync.run(beforeSubmitDataValidation(data));
    } else {
      resp = await store.notifications.createNewNotificationAsync.run(beforeSubmitDataValidation(data));
    }
    if (resp && resp.isSuccessful) {
      await store.notifications.getAllNotificationsAsync.run();
      toast('success', {
        body: ['Successfully saved']
      });
      handleModalClose();
    }
  };
  const fetchNotificationsDate = async () => {
    await store.notifications.getSpecificNotificationsAsync.run({
      id: currentId
    });
  };
  const handleBodyEdit = newValue => {
    if (!isBodyEdited) setIsBodyEdited(true);
    store.notifications.changeNewNotification('body', newValue);
  };
  useEffect(() => {
    if (isOpen && currentId) {
      fetchNotificationsDate();
    }
    return () => {
      store.notifications.resetNewNotification();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("div", {
    className: classes.modalBody
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('admin_page.banner_preview')), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, store.notifications.newNotification.appearanceType === 'banner' && /*#__PURE__*/React.createElement(InformationBanner, {
    type: store.notifications.newNotification.type,
    title: store.notifications.newNotification.title,
    text: store.notifications.newNotification.body,
    btnLink: store.notifications.newNotification.button === 'visible' ? store.notifications.newNotification.buttonLink : '',
    btnTitle: store.notifications.newNotification.button === 'visible' ? store.notifications.newNotification.buttonTitle : ''
  }), store.notifications.newNotification.appearanceType !== 'banner' && /*#__PURE__*/React.createElement("div", {
    className: classes.modalPreview
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.modalPreviewTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, store.notifications.newNotification.title || 'Notification title')), /*#__PURE__*/React.createElement("div", {
    className: classes.modalPreviewContent
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "div"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.textContent,
    dangerouslySetInnerHTML: {
      __html: DOMPurify.sanitize(store.notifications.newNotification.body)
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, !!store.notifications.newNotification.termsOfConditions && /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, null),
    label: /*#__PURE__*/React.createElement("span", null, t('general.i_agree_with'), ' ', /*#__PURE__*/React.createElement("span", {
      className: classes.link
    }, t('general.terms_and_conditions')))
  }), !!store.notifications.newNotification.privacyPolicy && /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, null),
    label: /*#__PURE__*/React.createElement("span", null, t('general.i_agree_with'), ' ', /*#__PURE__*/React.createElement("span", {
      className: classes.link
    }, t('general.privacy_policy')))
  }), !!store.notifications.newNotification.userAcknowledgement && /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, null),
    label: /*#__PURE__*/React.createElement("span", null, t('general.i_agree_with'), ' ', /*#__PURE__*/React.createElement("span", {
      className: classes.link
    }, t('general.user_acknowledgment')))
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "priority",
    type: "button",
    'custom-attribute': '541-InformationBannersAddForm'
  }, t('admin_page.complete'))))), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('admin_page.banner_configuration'))), /*#__PURE__*/React.createElement("div", {
    className: classes.settingsWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.settingsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Appearance type"), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    size: "small",
    value: store.notifications.newNotification.appearanceType,
    onChange: (e, value) => {
      if (value) store.notifications.changeNewNotification('appearanceType', value);
    },
    'custom-attribute': '542-InformationBannersAddForm',
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    'custom-attribute': '543-InformationBannersAddForm-banner',
    value: "banner"
  }, "Banner"), /*#__PURE__*/React.createElement(ToggleButton, {
    'custom-attribute': '543-InformationBannersAddForm-termsofservicesmodal',
    value: "termsofservicesmodal"
  }, "ToS")))), store.notifications.newNotification.appearanceType === 'banner' && /*#__PURE__*/React.createElement("div", {
    className: classes.settingsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('admin_page.type')), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    size: "small",
    value: store.notifications.newNotification.type,
    onChange: (e, value) => {
      if (value) store.notifications.changeNewNotification('type', value);
    },
    exclusive: true,
    'custom-attribute': '544-InformationBannersAddForm'
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "success",
    'custom-attribute': '545-InformationBannersAddForm-success'
  }, t('admin_page.success')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "info",
    'custom-attribute': '545-InformationBannersAddForm-info'
  }, t('admin_page.info')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "warning",
    'custom-attribute': '545-InformationBannersAddForm-warning'
  }, t('admin_page.warning')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "error",
    'custom-attribute': '545-InformationBannersAddForm-error'
  }, t('admin_page.error'))))), /*#__PURE__*/React.createElement("div", {
    className: classes.settingsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('admin_page.banner_title')), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "bannerTitle",
    name: "bannerTitle",
    variant: "outlined",
    value: store.notifications.newNotification.title,
    placeholder: t('admin_page.banner_title'),
    onChange: e => {
      if (!isTitleEdited) setIsTitleEdited(true);
      store.notifications.changeNewNotification('title', e.target.value);
    },
    onFocus: e => {
      if (!currentId && NOTIFICATION_DEFAULT.title === e.target.value) {
        store.notifications.changeNewNotification('title', '');
      }
    },
    onBlur: e => {
      if (!isTitleEdited && !currentId && e.target.value === '') {
        store.notifications.changeNewNotification('title', NOTIFICATION_DEFAULT.title);
      }
    },
    error: isTitleEdited && store.notifications.newNotification.title.trim().length === 0,
    helperText: isTitleEdited && store.notifications.newNotification.title.trim().length === 0 && 'Field is required'
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.settingsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('admin_page.banner_body_text')), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(ReactQuill, {
    modules: modules,
    theme: "snow",
    value: store.notifications.newNotification.body,
    onChange: newValue => {
      handleBodyEdit(newValue);
    }
  })), isBodyEdited && (store.notifications.newNotification.body.trim().length === 0 || store.notifications.newNotification.body.trim() === '<p><br></p>') && /*#__PURE__*/React.createElement(FormControl, {
    error: true
  }, /*#__PURE__*/React.createElement(FormHelperText, null, "Field is required"))), store.notifications.newNotification.appearanceType !== 'banner' && /*#__PURE__*/React.createElement("div", {
    className: classes.settingsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "List of conditions (Select at least one)"), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: store.notifications.newNotification.termsOfConditions,
      onChange: () => store.notifications.changeNewNotification('termsOfConditions', !store.notifications.newNotification.termsOfConditions)
    }),
    label: t('general.terms_and_conditions')
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: store.notifications.newNotification.privacyPolicy,
      onChange: () => store.notifications.changeNewNotification('privacyPolicy', !store.notifications.newNotification.privacyPolicy)
    }),
    label: t('general.privacy_policy')
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: store.notifications.newNotification.userAcknowledgement,
      onChange: () => store.notifications.changeNewNotification('userAcknowledgement', !store.notifications.newNotification.userAcknowledgement)
    }),
    label: t('general.user_acknowledgment')
  }))), store.notifications.newNotification.appearanceType === 'banner' && /*#__PURE__*/React.createElement("div", {
    className: classes.settingsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('admin_page.action_button')), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: store.notifications.newNotification.button,
    onChange: (e, value) => {
      if (value) store.notifications.changeNewNotification('button', value);
    },
    size: "small",
    exclusive: true,
    'custom-attribute': '546-InformationBannersAddForm'
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "hidden",
    'custom-attribute': '547-InformationBannersAddForm-hidden'
  }, t('admin_page.hidden')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "visible",
    'custom-attribute': '547-InformationBannersAddForm-visible'
  }, t('admin_page.visible')))), store.notifications.newNotification.button === 'visible' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('admin_page.action_button_title'),
    variant: "outlined",
    fullWidth: true,
    id: "buttonTitle",
    name: "buttonTitle",
    value: store.notifications.newNotification.buttonTitle,
    onChange: e => {
      if (!isButtonTitleEdited) setIsButtonTitleEdited(true);
      store.notifications.changeNewNotification('buttonTitle', e.target.value);
    },
    onFocus: e => {
      if (!currentId && NOTIFICATION_DEFAULT.buttonTitle === e.target.value) {
        store.notifications.changeNewNotification('buttonTitle', '');
      }
    },
    onBlur: e => {
      if (!isButtonTitleEdited && !currentId && e.target.value === '') {
        store.notifications.changeNewNotification('buttonTitle', NOTIFICATION_DEFAULT.buttonTitle);
      }
    },
    error: isButtonTitleEdited && store.notifications.newNotification.buttonTitle.trim().length === 0,
    helperText: isButtonTitleEdited && store.notifications.newNotification.buttonTitle.trim().length === 0 && 'Field is required'
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('admin_page.action_button_link'),
    variant: "outlined",
    fullWidth: true,
    id: "buttonLink",
    name: "buttonLink",
    value: store.notifications.newNotification.buttonLink,
    onChange: e => {
      if (!isButtonLinkEdited) setIsButtonLinkEdited(true);
      store.notifications.changeNewNotification('buttonLink', e.target.value);
    },
    onFocus: e => {
      if (!currentId && NOTIFICATION_DEFAULT.buttonLink === e.target.value) {
        store.notifications.changeNewNotification('buttonLink', '');
      }
    },
    onBlur: e => {
      if (!isButtonLinkEdited && !currentId && e.target.value === '') {
        store.notifications.changeNewNotification('buttonLink', NOTIFICATION_DEFAULT.buttonLink);
      }
    },
    error: isButtonLinkEdited && store.notifications.newNotification.buttonLink.trim().length === 0,
    helperText: isButtonLinkEdited && store.notifications.newNotification.buttonLink.trim().length === 0 && 'Field is required'
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.settingsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('admin_page.when_to_show_banner')), store.notifications.newNotification.appearanceType === 'banner' && /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: store.notifications.newNotification.dates,
    onChange: (e, value) => {
      if (value) store.notifications.changeNewNotification('dates', value);
    },
    size: "small",
    exclusive: true,
    'custom-attribute': '550-InformationBannersAddForm'
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "start",
    'custom-attribute': '551-InformationBannersAddForm-start'
  }, t('admin_page.only_start_date')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "start-end",
    'custom-attribute': '551-InformationBannersAddForm-start-end'
  }, t('admin_page.start_end_date')))), /*#__PURE__*/React.createElement("div", {
    className: classes.datePickerWrapper
  }, (store.notifications.newNotification.dates === 'start' || store.notifications.newNotification.appearanceType !== 'banner') && /*#__PURE__*/React.createElement(DatePicker, {
    format: "MM/dd/yy",
    label: t('admin_page.pick_date'),
    onChange: date => {
      if (date) {
        store.notifications.changeNewNotification('startDateOnly', formatISO(date).split('T')[0]);
      }
    },
    minDate: moment().toDate(),
    value: moment(store.notifications.newNotification.startDateOnly).toDate()
  }), store.notifications.newNotification.dates === 'start-end' && store.notifications.newNotification.appearanceType === 'banner' && /*#__PURE__*/React.createElement(RangeDatePicker, {
    label: t('admin_page.pick_dates_range'),
    minDate: moment().toDate(),
    fromDate: store.notifications.newNotification.endDateOnly ? moment(store.notifications.newNotification.startDateOnly).toDate() : moment().toDate(),
    toDate: store.notifications.newNotification.endDateOnly ? moment(store.notifications.newNotification.endDateOnly).toDate() : moment().add(2, 'days').toDate(),
    handleDateChange: dates => {
      if (dates.endDate) store.notifications.changeNewNotification('endDateOnly', formatISO(moment(dates.endDate).toDate()).split('T')[0]);
      if (dates.startDate) store.notifications.changeNewNotification('startDateOnly', formatISO(moment(dates.startDate).toDate()).split('T')[0]);
    }
  }))))), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleSubmit,
    disabled: store.account.getProfileAsync.inProgress || store.account.registerNewAccountAsync.inProgress || store.notifications.newNotification.body.trim().length === 0 || store.notifications.newNotification.body.trim() === '<p><br></p>' || store.notifications.newNotification.title.trim().length === 0 || store.notifications.newNotification.appearanceType === 'banner' && store.notifications.newNotification.button === 'visible' && (store.notifications.newNotification.buttonTitle.trim().length === 0 || store.notifications.newNotification.buttonLink.trim().length === 0) || store.notifications.newNotification.appearanceType === 'banner' && store.notifications.newNotification.dates === 'start-end' && (!store.notifications.newNotification.startDateOnly || !store.notifications.newNotification.endDateOnly) || store.notifications.newNotification.appearanceType !== 'banner' && !(store.notifications.newNotification.termsOfConditions || store.notifications.newNotification.privacyPolicy || store.notifications.newNotification.userAcknowledgement),
    variant: "priority",
    'custom-attribute': '548-InformationBannersAddForm-hidden'
  }, t('admin_page.save_banner'))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.notifications.createNewNotificationAsync.inProgress || store.notifications.putSpecificNotificationsAsync.inProgress || store.notifications.getSpecificNotificationsAsync.inProgress
  }));
});